
import Constains from '@/components/Constains';
import router from '@/router'
import { defineComponent, ref, onMounted, } from 'vue';
import { ConsoleSqlOutlined, UploadOutlined,} from '@ant-design/icons-vue';
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import 'dayjs/plugin/updateLocale';
import { useCookies } from 'vue3-cookies';
import axios from 'axios';
import { Input, notification } from 'ant-design-vue';
import type { TableColumnsType } from 'ant-design-vue';
import * as xlsx from 'sheetjs-style';
import locale from 'ant-design-vue/es/date-picker/locale/ja_JP';

export default defineComponent({
  components: {
    UploadOutlined,
  },
  setup() {
    const cookies  = useCookies();
    const input = ref(Input)

    const loading = ref(false)
    const commodityColumns = [
      //{    title:'商品コード',   dataIndex:'code',},
        {
            title:'JANコード・POSコード',
            dataIndex:'poscode',
        },
        {
            title:'商品名',
            dataIndex:'name',
        },
        {
            title:'税抜売価',
            dataIndex:'unitprice',
            width:'100px'
        },
        {
            title:'税込売価',
            dataIndex:'taxprice',
            width:'100px'
        },
        {
            title:'セール表示',
            dataIndex:'issale',
            width:'100px'
        },
        {
            title:'購入上限',
            dataIndex:'maxcount',
            width:'100px'
        },
        {
            title:'商品カテゴリ',
            dataIndex:'categorycode',
        },
        {
            title:'在庫管理システム側商品コード',
            dataIndex:'realcode',
            width:'170px'
        },
        {
            title:'在庫数',
            dataIndex:'stock',
            width:'100px'
        },
        {
            title:'販売開始日',
            dataIndex:'start',
            width:'100px'
        },
        {
            title:'販売終了日',
            dataIndex:'end',
            width:'100px'
        },
        {
            title:'分類',
            dataIndex:'pick',
            width:'70px'
        },
        {
            title:'商品画像',
            dataIndex:'image',
            width:'100px'
        },
        {
            title:'商品情報',
            dataIndex:'detail',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'120px'
        },
    ]
    const commodityDataSource:any = ref([])
    const commodityDataSourceIsSale:any = ref([])

    const commodityDetailColumns = [
        {
            title:'ラベル',
            dataIndex:'label',
        },
        {
            title:'内容',
            dataIndex:'value',
        },
        {
            title:'表示形式',
            dataIndex:'layout',
            width:'100px'
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]

    const adminColumns = [
        {
            title:'管理者コード',
            dataIndex:'code',
        },
        {
            title:'管理者名',
            dataIndex:'name',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const adminDataSource:any = ref([])

    const userColumns = ref<TableColumnsType>([
        {
            title:'LINE ID',
            dataIndex:'lineid',
            ellipsis: true,
            resizable: true,
            width:300,
        },
        {
            title:'お名前',
            dataIndex:'name',
            children:[
              {
                title: '姓',
                dataIndex: 'sei',
              },
              {
                title: '名',
                dataIndex: 'mei',
              },
              {
                title: 'セイ',
                dataIndex: 'seikana',
              },
              {
                title: 'メイ',
                dataIndex: 'meikana',
              },
            ],
        },
        {
          title:'性別',
          dataIndex:'sex',
        },
        {
          title:'生年月日',
          dataIndex:'birthdate'
        },
        {
            title:'電話番号',
            dataIndex:'tel',
        },
        {
            title:'郵便番号',
            dataIndex:'postalcode',
        },
        {
            title:'受取住所',
            dataIndex:'address',
        },
        {
            title:'ポイントカード番号',
            dataIndex:'pointcardcode',
        },
        {
            title:'登録日',
            dataIndex:'creationdate',
        },
        {
            title:'承認',
            dataIndex:'activated',
            width:'100px'
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ])
    const userDataSource:any = ref([])

    const categoryColumns = [
        {
            title:'カテゴリコード',
            dataIndex:'code',
        },
        {
            title:'カテゴリ名',
            dataIndex:'name',
        },
        {
            title:'親カテゴリ',
            dataIndex:'parentcode',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const categoryDataSource:any = ref([])
    const myShopCategoryDataSource:any = ref([])

    const receiptColumns = [
        {
            title:'伝票番号',
            dataIndex:'no',
        },
        {
            title:'購入日時',
            dataIndex:'creationdate',
        },
        {
            title:'購入者名',
            dataIndex:'name',
        },
        {
            title:'送り先住所',
            dataIndex:'address',
        },
        {
            title:'状態',
            dataIndex:'state',
        },
        {
            title:'配達希望時間',
            dataIndex:'estimateddeliverydate',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]

    const receiptDataSource:any = ref([])

    const expandedKeys = ref<string[]>([]);
    const editexpandedKeys = ref<string[]>([]);
    const selectedKeys = ref<string[]>([]);
    const editselectedKeys = ref<string[]>([]);
    const treeData:any = ref([])
    const treeDataMyShop = ref([])
    const treeVisible = ref(false)
    const categorySelectVisible = ref(false)
    const categorySelectedKeys = ref<string[]>([]);

    const pharmacyColumns = [
        {
            title:'薬局コード',
            dataIndex:'code',
        },
        {
            title:'薬局名',
            dataIndex:'name',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const pharmacyDataSource:any = ref([])

    const transporterColumns = [
        {
            title:'配送者コード',
            dataIndex:'code',
        },
        {
            title:'名称',
            dataIndex:'name',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const transporterDataSource:any = ref([])

    const shopColumns = [
        {
            title:'店舗コード',
            dataIndex:'code',
        },
        {
            title:'店舗名',
            dataIndex:'name',
        },
        {
            title:'住所',
            dataIndex:'address',
        },
        {
            title:'電話番号',
            dataIndex:'tel',
        },
        {
            title:'インボイスNo',
            dataIndex:'invoice',
        },
        {
            title:'ポイントカード倍率',
            dataIndex:'pointcardrate',
        },
        {
          title:'配送料',
          dataIndex:'shippingfee',
        },
        {
            title:'共通背景色',
            dataIndex:'color',
        },
        {
            title:'表示順',
            dataIndex:'sort',
        },
        {
            title:'消費税計算区分',
            dataIndex:'taxcalctype',
        },
        {
            title:'消費税端数処理',
            dataIndex:'taxfrac',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const shopDataSource:any = ref([])

    onMounted(async() => {
      dayjs.locale('ja')
      try{
        await shopReload()
        await commodityReload()
        await categoryReload()
        await categoryEditOpen(null)
        //pharmacyReload()
        adminReload()
        userReload()
        transporterReload()
        await receiptReload()
        await couponReload()
      } catch(e:any) {
        cookies.cookies.remove('token');
        cookies.cookies.remove('shopcode');
        router.push("/login")
      }
    })


    const getCategoryLabel = (code:string) => {
      const tmp = categoryDataSource.value.filter((e:any)=>e.code==code)
      if(tmp.length > 0) {
        let parent = tmp[0].parentcode
        let label = tmp[0].label
        while(parent != null){
          const t = categoryDataSource.value.filter((e:any)=>e.code==parent)
          if(t.length > 0){
            parent = t[0].parentcode
            label = t[0].label+'<br>→'+label
          } else {
            break
          }
        }
        return label
      }
      
      return 'No Data'
    }

    const commodityDetailAdd = () => {
      commodityData.value.detail.detail.push({
        layout:'horizontal',
      })
    }

    const commodityDetailRemove = (record:any) => {
      const index = commodityData.value.detail.detail.indexOf(record)
      commodityData.value.detail.detail.splice(index,1)
    }

    const commodityReload = async() => {
        commodityDataSource.value = []
        commodityDataSourceIsSale.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        
        const res = await axios.get(Constains.managementURL+'/api/commodity/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data.reverse()
          data.forEach((commodity:any) => {
            if(commodity.shopcode == shopcode){
              const detail =  JSON.parse(commodity.detail)
              commodity.issale = detail.issale
              commodity.saleoffprice = detail.saleoffprice
              commodityDataSource.value.push(commodity)
            }
          });
        }
        if(saleonly.value) commodityDataSourceIsSale.value = commodityDataSource.value.filter((e:any)=>e.issale)
        else commodityDataSourceIsSale.value = commodityDataSource.value
    }

    const commodityAdd = async(commodity:any) => {
      const token = cookies.cookies.get('token')
      loading.value = true
      try{
        const res = await axios.post(Constains.managementURL+'/api/commodity',JSON.stringify(commodity),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await commodityReload()
      }
      } catch(e){
        console.log(e)
      }
      
    }

    const commodityEdit = async(commodity:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/commodity',JSON.stringify(commodity),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await commodityReload()
      }
    }

    const commodityDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/commodity?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await commodityReload()
      }
      loading.value = false
    }

    const commodityVisible = ref(false)
    const commodityData:any = ref({ })

    const commodityEditOpen = (commodity:any) => {
      const shopcode = cookies.cookies.get('shopcode')
      if(commodity==null){
        commodityData.value.code = null
        commodityData.value.name = null
        commodityData.value.shopcode = shopcode
        commodityData.value.unitprice = null
        commodityData.value.taxtype = 0
        commodityData.value.maxcount = null
        commodityData.value.categorycode = null
        commodityData.value.realcode = null
        commodityData.value.stock = null
        commodityData.value.start = dayjs()
        commodityData.value.end = dayjs().add(1, 'y')
        commodityData.value.image = null
        commodityData.value.new = true
        commodityData.value.detail = {
          poscode:null,
          issale:false,
          saleoffprice:null,
          pick:0,
          detail:[],
        }
      } else {
        commodityData.value.code = commodity.code
        commodityData.value.name = commodity.name
        commodityData.value.shopcode = commodity.shopcode
        commodityData.value.unitprice = commodity.unitprice
        commodityData.value.taxtype = commodity.taxtype
        commodityData.value.maxcount = commodity.maxcount
        commodityData.value.categorycode = commodity.categorycode
        commodityData.value.realcode = commodity.realcode
        commodityData.value.stock = commodity.stock
        commodityData.value.start = commodity.start === null ? null : dayjs(commodity.start)
        commodityData.value.end = commodity.end === null ? null : dayjs(commodity.end)
        commodityData.value.image = commodity.image
        commodityData.value.detail = commodity.detail!=''? JSON.parse(commodity.detail):{}
        if(commodityData.value.detail.pick==null) commodityData.value.detail.pick=0
        commodityData.value.new = false
      } 
      commodityVisible.value = true
    }

    const commodityCopy = async(commodity:any) => {
        commodityData.value.code = null
        commodityData.value.name = commodity.name
        commodityData.value.shopcode = commodity.shopcode
        commodityData.value.unitprice = commodity.unitprice
        commodityData.value.taxtype = commodity.taxtype
        commodityData.value.maxcount = commodity.maxcount
        commodityData.value.categorycode = commodity.categorycode
        commodityData.value.realcode = commodity.realcode
        commodityData.value.stock = commodity.stock
        commodityData.value.start = dayjs(commodity.end).add(1,'d')
        commodityData.value.end = commodityData.value.start.add(1, 'y')
        commodityData.value.image = null
        commodityData.value.detail = commodity.detail!=''? JSON.parse(commodity.detail):{}
        commodityData.value.new = true

        commodityVisible.value = true
    }

    const commodityDisable = () => {
      if(commodityData.value.name == null) return true
      if(commodityData.value.unitprice == null) return true
      if(commodityData.value.maxcount == null) return true
      if(commodityData.value.categorycode == null) return true
      if(commodityData.value.stock == null) return true
      if(commodityData.value.start == null) return true
      if(commodityData.value.end == null) return true
      if(commodityData.value.image == null) return true

      return false
    }

    const commodityOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      commodityData.value.shopcode = shopcode
      if(commodityData.value.name == null) return
      if(commodityData.value.unitprice == null) return
      if(commodityData.value.maxcount == null) return
      if(commodityData.value.categorycode == null) return
      if(commodityData.value.stock == null) return
      if(commodityData.value.start == null) return
      if(commodityData.value.end == null) return
      if(commodityData.value.image == null) return


      if(commodityData.value.new){
        const detail = commodityData.value.detail.detail.filter((e:any)=>e.label&&e.label!=""&&e.value&&e.value!='')
        commodityData.value.detail.detail = detail
        const com = {
          shopcode:shopcode,
          name:commodityData.value.name,
          unitprice:commodityData.value.unitprice,
          taxtype:commodityData.value.taxtype,
          maxcount:commodityData.value.maxcount,
          categorycode:commodityData.value.categorycode,
          realcode:commodityData.value.realcode,
          stock:commodityData.value.stock,
          start:commodityData.value.start.format('YYYY/MM/DD'),
          end:commodityData.value.end.format('YYYY/MM/DD'),
          image:commodityData.value.image.split(',')[1],
          detail:JSON.stringify(commodityData.value.detail),
        }
        commodityAdd(com)
        
        commodityData.value.code = null
        commodityData.value.name = null
        commodityData.value.shopcode = shopcode
        commodityData.value.unitprice = null
        commodityData.value.maxcount = null
        commodityData.value.realcode = null
        commodityData.value.stock = null
        commodityData.value.image = null
        commodityData.value.new = true
        commodityData.value.detail = {
          poscode:null,
          issale:false,
          saleoffprice:null,
          detail:[],
        }
        loading.value = false
      } else {
        const detail = commodityData.value.detail.detail.filter((e:any)=>e.label&&e.label!=""&&e.value&&e.value!='')
        commodityData.value.detail.detail = detail
        const com = {
          shopcode:shopcode,
          code:commodityData.value.code,
          name:commodityData.value.name,
          unitprice:commodityData.value.unitprice,
          taxtype:commodityData.value.taxtype,
          maxcount:commodityData.value.maxcount,
          categorycode:commodityData.value.categorycode,
          realcode:commodityData.value.realcode,
          stock:commodityData.value.stock,
          detail:JSON.stringify(commodityData.value.detail),
        }
        commodityEdit(com)
        
        commodityData.value.code = null
        commodityData.value.name = null
        commodityData.value.shopcode = shopcode
        commodityData.value.unitprice = null
        commodityData.value.maxcount = null
        commodityData.value.realcode = null
        commodityData.value.stock = null
        commodityData.value.image = null
        commodityData.value.new = true
        commodityData.value.detail = {
          poscode:null,
          issale:false,
          saleoffprice:null,
          detail:[],
        }
        loading.value = false
        commodityVisible.value = false
      }
    }

    const fileSelect = () =>{
      input.value.click();
    }

    const selectedFile = () => {
      const file = input.value.files[0];
      const reader = new FileReader()
      if(file){
        reader.readAsDataURL(file)
        reader.onload = () => {
          //preview.value = true
          commodityData.value.image = reader.result as string
          //previewBase64.value = reader.result as string
          //formState.user.file = previewBase64.value
        }
      }
    }

    const adminVisible = ref(false)
    const adminData:any = ref({ })

    const adminEditOpen = (admin:any) => {
      if(admin==null){
        adminData.value.code = null
        adminData.value.name = null
        adminData.value.password = null
        adminData.value.new = true
      } else {
        adminData.value = JSON.parse(JSON.stringify(admin));
        adminData.value.new = false
      } 
      adminVisible.value = true
    }

    const adminOK = async() => {
      //adminData.value.shopcode = shopcode
      const shopcode = cookies.cookies.get('shopcode')
      const json = {
        shopcode:shopcode,
        scode:shopcode,
        code:adminData.value.code,
        name:adminData.value.name,
        password:adminData.value.password,
      }
      if(adminData.value.new){
        await adminAdd(json)
      } else {
        await adminEdit(json)
      }
      adminVisible.value = false
    }

    const adminReload = async() => {
      adminDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        const usercode = cookies.cookies.get('usercode')
        loading.value = true

        const res = await axios.get(Constains.managementURL+'/api/admin/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          data.forEach((admin:any) => {
            if(admin.shopcode == shopcode){
              admin.editable = admin.code == usercode
              adminDataSource.value.push(admin)
            }
             
          });
        }
        loading.value = false
    }

    const adminAdd = async(admin:any) => {
      const token = cookies.cookies.get('token')

      loading.value = true
      const res = await axios.post(Constains.managementURL+'/api/admin',JSON.stringify(admin),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await adminReload()
      }
    }

    const adminEdit = async(admin:any) => {
      
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      let json:any = {
        shopcode:shopcode,
        code:admin.code,
        name:admin.name,
      }
      if(admin.password){
        json.password = admin.password
      }
      loading.value = true
      try{
        const res = await axios.put(Constains.managementURL+'/api/admin',JSON.stringify(json),{headers:{
          //const res = await axios.put(Constains.managementURL+'/api/admin',json,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          await adminReload()
        }
      } catch (e){
        loading.value = false
        notification.error({message:'更新に失敗しました.'})
      }
      
    }

    const adminDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/admin?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await adminReload()
      }
    }

    const transporterVisible = ref(false)
    const transporterData:any = ref({ })

    const transporterEditOpen = (transporter:any) => {
      if(transporter==null){
        transporterData.value.code = null
        transporterData.value.name = null
        transporterData.value.new = true
      } else {
        transporterData.value = JSON.parse(JSON.stringify(transporter));
        transporterData.value.new = false
      } 
      transporterVisible.value = true
    }

    const transporterOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      transporterData.value.shopcode = shopcode
      if(transporterData.value.new){
        await transporterAdd(transporterData.value)
      } else {
        await transporterEdit(transporterData.value)
      }
      transporterVisible.value = false
    }

    const transporterReload = async() => {
        transporterDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/transporter/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          data.forEach((transporter:any) => {
            let push = {
              code:transporter.code,
              name:transporter.name,
              value:transporter.code,
              label:transporter.name,
            }
            transporterDataSource.value.push(push)
          });
        }
        loading.value = false
    }

    const transporterAdd = async(transporter:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.post(Constains.managementURL+'/api/transporter',JSON.stringify(transporter),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await transporterReload()
      }
    }

    const transporterEdit = async(transporter:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/transporter',JSON.stringify(transporter),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await transporterReload()
      }
    }

    const transporterDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/transporter?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await transporterReload()
      }
    }

    const userVisible = ref(false)
    const userData:any = ref({ })

    const userEditOpen = (user:any) => {
      userData.value = JSON.parse(JSON.stringify(user));
      userVisible.value = true
    }

    const userOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      userData.value.shopcode = shopcode
      await userEdit(userData.value)
      /*
      if(userData.value.code == null){
        await userAdd(userData)
      } else {
        await userEdit(userData)
      }*/
      userVisible.value = false
    }

    const userReload = async() => {
        userDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/user/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          data.forEach((user:any) => {
            let push = user

            try{
              const name = JSON.parse(user.name)
              push.sei = name.sei
              push.mei = name.mei
              push.seikana = name.seikana
              push.meikana = name.meikana
            } catch{
              push.sei = user.name
            }
            
            try{
              const address = JSON.parse(user.address)
              address.address = address.prefecture+address.city+address.town+address.building
              //push.address = '〒'+address.postalcode1+'-'+address.postalcode1+' '+address.prefecture+address.city+address.town+address.building
              push.address = address
            }catch(a){
              //
            }
            try{
              const detail = JSON.parse(user.detail)
              push.sex = detail.sex
              push.birthdate = detail.birth.year+'年'+detail.birth.month+'月'
            } catch {
              push.detail = {}
            }

            userDataSource.value.push(push)
          });
        }
        loading.value = false
    }

    const userAdd = async(user:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.post(Constains.managementURL+'/api/user',JSON.stringify(user),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await userReload()
      }
    }

    const userEdit = async(user:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/user',JSON.stringify(user),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await userReload()
      }
    }

    const userDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/user?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await userReload()
      }
    }

    const categoryVisible = ref(false)
    const categoryData:any = ref({ })

    const categoryEditOpen = (category:any) => {
      const shopcode = cookies.cookies.get('shopcode')
      if(category==null){
        editBaseCategoryCode = null
        categoryData.value.shopcode = shopcode
        categoryData.value.code = null
        categoryData.value.name = null
        categoryData.value.sortweight = 0
        categoryData.value.detail = {
          icon:null,
          color:null,
        }
        categoryData.value.new = true
        categoryData.value.disabled = false
      } else if(category.length == 1) {
        const tmp = categoryDataSource.value.filter((e:any)=>e.code==category[0])
        if(tmp.length > 0){
          const editcategory = tmp[0]
          categoryData.value.shopcode = editcategory.shopcode
          editBaseCategoryCode = editcategory.code
          categoryData.value.code = editcategory.code
          categoryData.value.name = editcategory.name
          categoryData.value.parentcode = editcategory.parentcode
          categoryData.value.sortweight = editcategory.sortweight
          categoryData.value.detail = editcategory.detail
          categoryData.value.new = false
          categoryData.value.disabled = editcategory.disabled
        }
//        categoryData.value.code = category[0]
      } else if(category.length === undefined){
          categoryData.value.shopcode = category.shopcode
          editBaseCategoryCode = category.code
          categoryData.value.code = category.code
          categoryData.value.name = category.name
          categoryData.value.parentcode = category.parentcode
          categoryData.value.sortweight = category.sortweight
          categoryData.value.detail = category.detail
          categoryData.value.new = false
          categoryData.value.disabled = category.disabled
      }
      //editexpandedKeys.value.push(category)
      /*
      if(category==null){
        categoryData.value.code = null
        categoryData.value.name = null
        categoryData.value.parentcode = null
        categoryData.value.sortweight = 0
        categoryData.value.new = true
      } else {
        categoryData.value.code = category.code
        categoryData.value.name = category.name
        categoryData.value.parentcode = category.parentcode
        categoryData.value.sortweight = 0
        categoryData.value.new = false
      } */
      //categoryVisible.value = true
    }

    const categoryOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      if(categoryData.value.detail == null) categoryData.value.detail = {}
      const json = {
        shopcode:shopcode,
        scode:categoryData.value.shopcode,
        code:categoryData.value.code,
        name:categoryData.value.name,
        parentcode:categoryData.value.parentcode,
        sortweight :categoryData.value.sortweight,
        detail:JSON.stringify(categoryData.value.detail)
      }
      
      try{
        if(categoryData.value.new){
          await categoryAdd(json)
          editBaseCategoryCode = null
          categoryData.value.code = null
          categoryData.value.name = null
          categoryData.value.sortweight++
          categoryData.value.detail = {}
          categoryData.value.new = true
        } else {
          await categoryEdit(json)
          categoryVisible.value = false
        }
        notification.success({message:'カテゴリーの編集に成功しました'})
      } catch (e){
        console.log(e)
        notification.error({message:'カテゴリーの編集に失敗しました'})
      }
      
      
    }

    const categoryDisabled = () => {
      /*
      if(categoryData.value.code == Constains.shopRootCode) return true
      if(categoryData.value.code == Constains.dragstoreRootCode) return true
      */
      return false
    }

    let editBaseCategoryCode = null

    const categoryReload = async() => {
        categoryDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/category/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          let tree:any = []
          let myshoptree:any = []
          /*
          let tree:any = [
            {
              title:Constains.shopRootName,
              key:Constains.shopRootCode,
              children: []
            },
            {
              title:Constains.dragstoreRootName,
              key:Constains.dragstoreRootCode,
              children: []
            }
          ]
          */

          data.forEach((category:any) => {
            if(category.shopcode == shopcode){
              categoryDataSource.value.push({
              shopcode:category.shopcode,
              code:category.code,
              name:category.name,
              value:category.code,
              label:category.name,
              parentcode:category.parentcode,
              disabled:category.shopcode != shopcode,
              sortweight:category.sortweight,
              detail: category.detail !='' ? JSON.parse(category.detail) : {}
            })
            if(category.parentcode == null){
              tree.push({
                title:category.name,
                key:category.code,
                shopcode:category.shopcode,
                disabled: shopcode != category.shopcode,
                children: []
              })
              if(shopcode == category.shopcode){
                myshoptree.push({
                title:category.name,
                key:category.code,
                shopcode:category.shopcode,
                children: []
              })
              }
            }}
          });
          
          tree.forEach((item:any)=>{
            addChildren(item)
          })
          myshoptree.forEach((item:any)=>{
            addChildren(item)
          })
          treeData.value = tree
          treeDataMyShop.value = myshoptree
        }

        myShopCategoryDataSource.value = categoryDataSource.value.filter((e:any)=>e.shopcode == shopcode)
        loading.value = false
    }
    

    const addChildren = (parent:any) => {
      const tmp = categoryDataSource.value.filter((e:any)=>e.parentcode==parent.key&&e.parentcode!=null&&e.shopcode==parent.shopcode)
      const shopcode = cookies.cookies.get('shopcode')
      
      tmp.forEach((item:any)=>{
        const push = {
          title:item.name,
          key:item.code,
          shopcode:item.shopcode,
          disabled: shopcode != item.shopcode,
          children: []
        }
        parent.children.push(push)
        addChildren(push)
      })
      
    }

    const getParentCategory = (parent:string) => {
      const tmp = categoryDataSource.value.filter((e:any)=>e.code==parent)
      if(tmp.length > 0 ) return tmp[0].name
      return ""
    }

    const categoryAdd = async(category:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.post(Constains.managementURL+'/api/category',JSON.stringify(category),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                //'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Control-Allow-Origin':'*',
                }});
      if(res.status == 200){
        await categoryReload()
      }
    }

    const categoryEdit = async(category:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/category',JSON.stringify(category),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin':'*',
                }});
      if(res.status == 200){
        await categoryReload()
      }
    }

    const categoryDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/category?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await categoryReload()
      }
    }

    const pharmacyVisible = ref(false)
    const pharmacyData:any = ref({ })

    const pharmacyEditOpen = (pharmacy:any) => {
      if(pharmacy==null){
        pharmacyData.value.code = null
        pharmacyData.value.name = null
        pharmacyData.value.new = true
      } else {
        pharmacyData.value.code = pharmacy.code
        pharmacyData.value.name = pharmacy.name
        pharmacyData.value.new = false
      } 
      pharmacyVisible.value = true
    }

    const pharmacyOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      pharmacyData.value.shopcode = shopcode
      if(pharmacyData.value.new){
        await pharmacyAdd(pharmacyData.value)
      } else {
        await pharmacyEdit(pharmacyData.value)
      }
      pharmacyVisible.value = false
    }

    const pharmacyReload = async() => {
        pharmacyDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        const res = await axios.get(Constains.managementURL+'/api/pharmacy/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          data.forEach((pharmacy:any) => {
            pharmacyDataSource.value.push(pharmacy)
          });
        }
        loading.value = false
    }

    const pharmacyAdd = async(pharmacy:any) => {
      const token = cookies.cookies.get('token')
      //const json = {shopcode:shopcode,receiptno:receipt.no}
      loading.value = true
      const res = await axios.post(Constains.managementURL+'/api/pharmacy',JSON.stringify(pharmacy),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await pharmacyReload()
      }
    }

    const pharmacyEdit = async(pharmacy:any) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      let json:any = {
        shopcode:shopcode,
        code:pharmacy.code,
        name:pharmacy.name,
      }
      if(pharmacy.password){
        json.password = pharmacy.password
      }

      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/pharmacy',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await pharmacyReload()
      }
    }

    const pharmacyDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/pharmacy?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await pharmacyReload()
      }
    }

    const handleResizeColumn = (w:any, col:any) => {
      col.width = w;
    }

    const copyToClipboard = (str:any) => {
      if (navigator.clipboard){
        navigator.clipboard.writeText(str)
      } 
    }

    const filterOption = (input: string, option: any) => {
      return (option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0) || (option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    };

    const setParent = () => {
      if(selectedKeys.value.length){
        
        const tmp = categoryDataSource.value.filter((e:any)=>e.code==selectedKeys.value[0])
        if(tmp.length > 0){
          categoryData.value.shopcode = tmp[0].shopcodeg
        } else {
          categoryData.value.shopcode = null
        }
        categoryData.value.parentcode = selectedKeys.value[0]
      }
      treeVisible.value = false
    }

    const categorySelect = () => {
      if(categorySelectedKeys.value.length){
        commodityData.value.categorycode = categorySelectedKeys.value[0]
      }
      categorySelectVisible.value = false
    }

    const receiptVisible = ref(false)
    const receiptData:any = ref({ })

    const receiptReload = async() => {
        receiptDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        const json = {shopcode:shopcode,needdetail:true}
        loading.value = true
        const res = await axios.post(Constains.baseURL+'/listundispatched',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const data = res.data
          const nineFinish = dayjs().hour(9).minute(0).second(0)
          const twelveFinish = dayjs().hour(12).minute(0).second(0)
          data.forEach((receipt:any) => {
            if(receipt.shopcode == shopcode){
              let push = JSON.parse(JSON.stringify(receipt))
              push.sorthopedate = dayjs(receipt.estimateddeliverydate)
              push.isNine=dayjs(receipt.creationdate).isBefore(nineFinish)
              push.isTwelve=dayjs(receipt.creationdate).isBefore(twelveFinish)&&(dayjs(receipt.creationdate).isAfter(nineFinish)||dayjs(receipt.creationdate).isSame(nineFinish))
              push.tel = userDataSource.value.filter((e:any)=>e.lineid==receipt.lineid)[0].tel
              push.interval = receipt.estimateddeliverydate+'~'+dayjs(receipt.estimateddeliverydate).add(2,'h').format('HH:mm')
            try{
              const address = JSON.parse(receipt.address)
              push.address = '〒'+address.postalcode+' '+address.prefecture+address.city+address.town+address.building
              push.postcode = '〒'+address.postalcode
              push.prefecture = address.prefecture
              push.city = address.city
              push.town = address.town
              push.building = address.building
            }catch{
              push.prefecture = receipt.address
            }
            try{
              const name = JSON.parse(receipt.name)
              push.sei = name.sei
              push.mei = name.mei
              push.seikana = name.seikana
              push.meikana = name.meikana
            }catch{
              push.sei = receipt.name
            }
            receiptDataSource.value.push(push)
            }
          });
          receiptDataSource.value.sort((a:any,b:any)=>{
            return a.sorthopedate.isAfter(b.sorthopedate) ?  1 : -1
          })
        }
        OrderSummaryDataSource.value = await getOrderSummaryDataSource()
        loading.value = false
    }

    const ReceiptDetailColumns = [
      {
        title:'JANコード・POSコード',
        dataIndex:'poscode',
      },
      {
        title:'商品名',
        dataIndex:'name',
      },
      {
        title:'在庫管理システム側商品コード',
        dataIndex:'realcode',
      },
      {
        title:'分類',
        dataIndex:'type',
      },
      {
        title:'税抜売価',
        dataIndex:'unitprice',
      },
      {
        title:'税込売価',
        dataIndex:'taxprice',
      },
      {
        title:'購入数',
        dataIndex:'count',
      },
      {
        title:'合計額',
        dataIndex:'sum',
      },
    ]

    const ReceiptDetailDataSource:any = ref([])

    const dlReceiptData:any = ref()

    const loadReceipt = async(receipt:any) => {
      dlReceiptData.value = receipt
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true

      receiptData.value.receiptno = receipt.no
      receiptData.value.shopcode = shopcode
      receiptData.value.state = 1
      receiptData.value.transportercode = null
      ReceiptDetailDataSource.value = []

      receiptVisible.value = true
      
      const json = {shopcode:shopcode,receiptno:receipt.no}
      const res = await axios.post(Constains.baseURL+'/loadreceipt',JSON.stringify(json),{headers:{
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        ReceiptDetailDataSource.value = res.data.details
        if(res.data.state == 1) {
          loading.value = false
          return
        } else {
          receiptData.value.state = res.data.state
        }
      }

      transporterDataSource.value.forEach(async(staff:any) => {
        try{
          const json = {shopcode:shopcode,transportercode:staff.code}
          const res = await axios.post(Constains.baseURL+'/listsending',JSON.stringify(json),{headers:{
                    'Content-Type': 'application/json',
          }});
          if(res.status == 200){
            const data = res.data
            data.forEach((item:any) => {
              if(item.no == receipt.no){
                receiptData.value.transportercode = staff.code
                loading.value = false
                return
              }
            })
          }
        } catch (e){
          //console.log(e)
        }
      })
      
      loading.value = false
    }

    const ReceiptDownload = async(receipt:any) => {
      let address = receipt.prefecture + receipt.city + receipt.town + receipt.building
      let name = receipt.sei +' ' + receipt.mei
      let namekana = receipt.seikana +' ' +  receipt.meikana

      //店舗情報
      const shop = shopDataSource.value.filter((e:any)=>e.code==receipt.shopcode)[0]
      const shopname = shop.label
      const invoice = shop.detail.invoice

      const whiteFrame = 'FFFFFF'
      const blackFrame = '000000'
      const lightgrayFrame = 'd3d3d3'
      const grayFrame = '808080'
      const headerColor = '9cd4ac'
      const sumColor = 'b0dafe' 
      const projectsumColor = '64B7FE' 
      const totalColor = 'FFCC99'
      const differenceColor = '006AB6'
      const undifferenceColor = 'FF0000'
      
      const baseColumn = 1; 
      const startRow = 2;
      let currentRow = startRow + 2;
      const merge = [];

      const fontSize = 16;
      const labelFontSize = 12;
      const familyname = '游ゴシック';

      //記入を開始
      const worksheet = xlsx.utils.json_to_sheet([])

      //伝票番号を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:'伝票番号：',t:'s',w:'伝票番号：',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } },
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:receipt.no,t:'s',w:receipt.no,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } },
            font:{
              sz:24,
              name:familyname,
            },
            alignment: { vertical:'center', }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+2)+(currentRow-1)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              //top:{style:'thin', color:{ rgb: grayFrame }},
              //left:{style:'thin', color:{ rgb: whiteFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              //right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+3)+(currentRow)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
      }

      //ストア情報枠
      {
        worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
          v:shop.name,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              sz:14,
              name:familyname,
            }
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+4)+(currentRow+1)] = {
          v:shop.detail.address,
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              sz:14,
              name:familyname,
            }
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+5)+(currentRow-1)] = {
          v:'',
          s:{
            border:{
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+6)+(currentRow-1)] = {
          v:'',
          s:{
            border:{
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+7)+(currentRow)] = {
          v:shop.detail.tel,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              sz:12,
              name:familyname,
            }
          }
        } 
        worksheet[xlsx.utils.encode_col(baseColumn+7)+(currentRow+1)] = {
          v:'',
          s:{
            border:{
              right:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
      }

      currentRow++;

      //名前を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:'お名前：',t:'s',w:'お名前：',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,sz:labelFontSize,
              name:familyname,
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:'(姓)'+receipt.sei+' (名)'+receipt.mei+' 様',t:'s',w:'(姓)'+receipt.sei+' (名)'+receipt.mei+' 様',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } },
            font:{
              sz:14,
              name:familyname,
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
          v:'(ｾｲ)'+receipt.seikana+' (ﾒｲ)'+receipt.meikana+' ｻﾏ',t:'s',w:'(ｾｲ)'+receipt.seikana+' (ﾒｲ)'+receipt.meikana+' ｻﾏ',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              sz:14,
              name:familyname,
            }
          }
        }
      }
      currentRow++;
      
      //住所を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:'お届け先：',t:'s',w:'お届け先：',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:receipt.address,t:'s',w:receipt.address,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              sz:fontSize,
              name:familyname,
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+3)+currentRow] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
      }

      //事業者番号等を記入
      {
        merge.push({ s: { r: currentRow-1, c: baseColumn+4 }, e: { r: currentRow-1, c: baseColumn+5 } },)
        worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
          v:'事業者番号',t:'s',w:'事業者番号',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: whiteFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            }
          }
        }
        
        worksheet[xlsx.utils.encode_col(baseColumn+5)+(currentRow)] = {
          v:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+6)+currentRow] = {
          v:'検品',t:'s',w:'検品',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            }
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+7)+currentRow] = {
          v:'配達',t:'s',w:'配達',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            }
          }
        }
      }

      currentRow++;

      //電話番号を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:'ご連絡先：',t:'s',w:'ご連絡先：',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:receipt.tel,t:'s',w:receipt.tel,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } },
            font:{sz:fontSize,name:familyname,}
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
          v:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: whiteFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        } 
      }

      //事業者番号等の枠を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
          v:invoice,t:'s',w:invoice,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: whiteFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            font:{sz:14,name:familyname,}
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+6)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: whiteFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+7)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: whiteFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
      }
      currentRow++;

      //希望日時を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:'配送希望日時：',t:'s',w:'配送希望日時：',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
          }
        }
        const est =dayjs(receipt.estimateddeliverydate)
        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:est.format('YYYY/MM/DD'),t:'s',w:est.format('YYYY/MM/DD'),
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } },
            font:{
              sz:fontSize,
              name:familyname,
            } 
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
          v:est.format('HH:mm'),t:'s',w:est.format('HH:mm'),
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              sz:fontSize,
              name:familyname,
            }
          }
        } 
      }
      //事業者番号等の枠を記入
      {
        worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: whiteFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+5)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: whiteFrame }},
              left:{style:'thin', color:{ rgb: whiteFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+6)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: whiteFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+7)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: whiteFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }
      }
      currentRow++;
      currentRow++;
      const pickingSheet = JSON.parse(JSON.stringify(worksheet))
      let pickingRow = currentRow
      //購入者用メッセージ記入欄
      const customerMessageStartRow =  currentRow;
      currentRow++;
      currentRow++;
      currentRow++;
      currentRow++;
      currentRow++;

      //ヘッダを作成
      const Row_jaccd = baseColumn
      const Row_instore = baseColumn+1
      const Row_name = baseColumn+2
      const Row_category = baseColumn+3
      const Row_count = baseColumn+4
      const Row_taxrate = baseColumn+5
      const Row_unitprice = baseColumn+6
      const Row_sum = baseColumn+7
      for(let i = 0;Row_jaccd+i<=Row_sum;i++){
        let label = ''
        if(i==0) label='JANCD'
        else if(i==1) label='インストアCD'
        else if(i==2) label='商品名'
        else if(i==3) label='大分類'
        else if(i==4) label='数量'
        else if(i==5) label='消費税率'
        else if(i==6) label='単価(税抜)'
        else if(i==7) label='小計(税抜)'
        worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
          v:label,t:'s',w:label,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }

        if(i==5) label= 'ピッキング'
        else if(i==6) label= '三温'
        else if(i==7) label= 'パッキング'

        pickingSheet[xlsx.utils.encode_col(Row_jaccd+i)+pickingRow] = {
          v:label,t:'s',w:label,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
      }
      currentRow++;
      pickingRow++;

      let count_taxType0 = 0
      let count_taxType1 = 0
      let sum_priceType0 = 0
      let sum_priceType1 = 0
      let sum_taxType0 = 0
      let sum_taxType1 = 0

      receipt.details.forEach((commodity:any) => {
        console.log('commodity',commodity)
        let commoditydetail:any = {}
        try{
          commoditydetail = JSON.parse(commodity.commoditydetail)
        } catch {
          //
        }
        
        let isCoupon = commodity.unitprice < 0
        if(!isCoupon){
          const couponfilter = receipt.details.filter((e:any)=>e.unitprice < 0 && e.commoditycode == commoditydetail.poscode && e.wroten!=true &&e.count==commodity.count)
          console.log('couponfilter',couponfilter)
          if(couponfilter.length==1){
            couponfilter[0].wroten=true
            commodity.unitprice += couponfilter[0].unitprice
          }
        }
        const taxtypecheck =  Math.ceil( commodity.taxrate * 100)
        console.log('taxtypecheck',taxtypecheck,commodity.taxrate)
        if(!isCoupon){
          if(taxtypecheck == 10) {
            count_taxType0 += commodity.count
            if(taxfrac == 0) {
              sum_taxType0 += Math.floor(commodity.unitprice * commodity.count * 0.10)
            } else if(taxfrac == 1){
              sum_taxType0 += Math.ceil(commodity.unitprice * commodity.count * 0.10)
            } else if(taxfrac == 2){
              sum_taxType0 += Math.round(commodity.unitprice * commodity.count * 0.10)
            } else {
              sum_taxType0 += Math.floor(commodity.unitprice * commodity.count * 0.10)
            }
            
            sum_priceType0 += commodity.unitprice * commodity.count
          }
          else {
            count_taxType1 += commodity.count
            if(taxfrac == 0) {
              sum_taxType1 += Math.floor(commodity.unitprice * commodity.count * 0.08)
            } else if(taxfrac == 1){
              sum_taxType1 += Math.ceil(commodity.unitprice * commodity.count * 0.08)
            } else if(taxfrac == 2){
              sum_taxType1 += Math.round(commodity.unitprice * commodity.count * 0.08)
            } else {
              sum_taxType1 += Math.floor(commodity.unitprice * commodity.count * 0.08)
            }
            sum_priceType1 += commodity.unitprice * commodity.count
          }
        }
        let value = ''
        for(let i = 0;Row_jaccd+i<=Row_sum;i++){
          if(i==0){
            if(isCoupon) value='ｸｰﾎﾟﾝ'
            else value = commoditydetail.poscode
          } 
          else if(i==1) {
            if(isCoupon) value='ｸｰﾎﾟﾝ'
            else value = getRealcode(commodity.commoditycode)
          } 
          else if(i==2) value=commodity.name
          else if(i==3) {
            if(isCoupon) value='ｸｰﾎﾟﾝ'
            else {
              try{
                const commodity_tmp = commodityDataSource.value.filter((e:any)=>e.code==commodity.commoditycode)[0]
                const category_tmp = categoryDataSource.value.filter((e:any)=>e.code==commodity_tmp.categorycode)
                if(category_tmp.length > 0) {
                  value = category_tmp[0].label
                  let parent = category_tmp[0].parentcode
                  while(parent != null){
                    const t = categoryDataSource.value.filter((e:any)=>e.code==parent)
                    if(t.length > 0){
                      parent = t[0].parentcode
                      value = t[0].label
                    } else {
                      break
                    }
                  }
                }
              } catch{
                //
              }
            }
            
          }
          else if(i==4) value=commodity.count
          else if(i==5) {
            if(isCoupon) value=''
            else value = taxtypecheck.toString()+'%'
          }
          else if(i==6) {
            if(isCoupon) value=''
            else {
              value=commodity.unitprice
            }
              
          }
          else if(i==7) {
            if(isCoupon)  value=''
            else 
               value=(commodity.unitprice * commodity.count).toString()
          }
          if(i==0||i==1){
            worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                fill: { fgColor: { rgb: whiteFrame } },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
                alignment:{
                  horizontal:'right',
                }
              }
            }
          }
          else if(i==5){
            //消費税率の場合中央寄せ
            worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                fill: { fgColor: { rgb: whiteFrame } } ,
                font:{
                  sz:fontSize,
                  name:familyname,
                },
                alignment:{
                  horizontal:'center',
                }
              }
            }

          } else if(i==4||i==6||i==7){
            //数字の場合右寄せ
            worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
              v:value,t:'n',w:value,z:'#,##0',
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                fill: { fgColor: { rgb: whiteFrame } },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
              }
            }

          } else {
            worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                fill: { fgColor: { rgb: whiteFrame } },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
              }
            }
          }

          if(i==5) value = ''
          else if(i==6) {
            value = ''
            if(!isCoupon){
              if(commoditydetail.pick == 0) value='常温'
              else if(commoditydetail.pick == 1) value='チルド'
              else if(commoditydetail.pick == 2) value='冷凍'
            }
          }
          else if(i==7) value = ''

          if(i==0||i==1){
            pickingSheet[xlsx.utils.encode_col(Row_jaccd+i)+pickingRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
                alignment:{
                  horizontal:'right',
                }
              }
            }
          } else if(i==4){
            pickingSheet[xlsx.utils.encode_col(Row_jaccd+i)+pickingRow] = {
              v:value,t:'n',w:value,z:'#,##0',
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
              }
            }
          } else if(i==6){
            pickingSheet[xlsx.utils.encode_col(Row_jaccd+i)+pickingRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                alignment:{
                  horizontal:'center',
                },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
              }
            }
          } else {
            pickingSheet[xlsx.utils.encode_col(Row_jaccd+i)+pickingRow] = {
              v:value,t:'s',w:value,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                font:{
                  sz:fontSize,
                  name:familyname,
                },
              }
            }
          }
        }
        currentRow++;
        pickingRow++
      });
      
      currentRow++;
      pickingRow++
      count_taxType0++
      sum_priceType0 += shop.detail.shippingfee
      if(taxfrac == 0) {
        sum_taxType0 += Math.floor(shop.detail.shippingfee*0.1)
      } else if(taxfrac == 1){
        sum_taxType0 += Math.ceil(shop.detail.shippingfee*0.1)
      } else if(taxfrac == 2){
        sum_taxType0 += Math.round(shop.detail.shippingfee*0.1)
      } else {
        sum_taxType0 += Math.floor(shop.detail.shippingfee*0.1)
      }
      
      for(let i = 0;Row_jaccd+i<=Row_sum;i++){
        let value = ''
        if(i==0){ value = '配送料' } 
        else if(i==4) value='1'
        else if(i==5) value = '10%'
        else if(i==6) value=shop.detail.shippingfee
        else if(i==7) value=shop.detail.shippingfee

        worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow] = {
          v:value,t:'s',w:value,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              sz:fontSize,
              name:familyname,
            },
          }
        }
        if(i==0){
          worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow].s.font= { bold:true,sz:labelFontSize,name:familyname, }
          worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow].s.alignment= { horizontal:'center', }
        } else if( i== 5){
          worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow].s.alignment= { horizontal:'center', }
        } else if(i == 4 || i==6 || i == 7){
          worksheet[xlsx.utils.encode_col(Row_jaccd+i)+currentRow].t='n'
        } 
      }
      currentRow++;
      currentRow++;
      worksheet[xlsx.utils.encode_col(Row_taxrate)+currentRow] = {
        v:'10%対象(税抜)',t:'s',w:'10%対象(税抜)',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } ,
          font:{
            bold:true,
            sz:labelFontSize,
            name:familyname,
          },
          alignment:{
            horizontal:'center',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_unitprice)+currentRow] = {
        v:count_taxType0+'点',t:'s',w:count_taxType0+'点',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          alignment:{
            horizontal:'right',
          },
          font:{
            sz:fontSize,
            name:familyname,
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_sum)+currentRow] = {
        v:sum_priceType0,t:'n',w:sum_priceType0,z:'#,##0',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{
            sz:fontSize,
            name:familyname,
          },
        }
      }
      currentRow++;
      worksheet[xlsx.utils.encode_col(Row_taxrate)+currentRow] = {
        v:'8%対象(税抜)',t:'s',w:'8%対象(税抜)',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{
            bold:true,
            sz:labelFontSize,
            name:familyname,
          },
          alignment:{
            horizontal:'center',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_unitprice)+currentRow] = {
        v:count_taxType1+'点',t:'s',w:count_taxType1+'点',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          alignment:{
            horizontal:'right',
          },
          font:{
            sz:fontSize,
            name:familyname,
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_sum)+currentRow] = {
        v:sum_priceType1,t:'n',w:sum_priceType1,z:'#,##0',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{
            sz:fontSize,
            name:familyname,
          },
        }
      }
      currentRow++;
      currentRow++;

      //消費税の額を記入
      worksheet[xlsx.utils.encode_col(Row_taxrate)+currentRow] = {
        v:'10%消費税',t:'s',w:'10%消費税',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{
            bold:true,
            sz:labelFontSize,
            name:familyname,
          },
          alignment:{
            horizontal:'center',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_unitprice)+currentRow] = {
        v:count_taxType0+'点',t:'s',w:count_taxType0+'点',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } ,
          font:{ sz:fontSize,name:familyname,},
          alignment:{
            horizontal:'right',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_sum)+currentRow] = {
        v:sum_taxType0,t:'n',w:sum_taxType0,z:'#,##0',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } ,
          font:{ sz:fontSize,name:familyname,},
        }
      }
      currentRow++;
      worksheet[xlsx.utils.encode_col(Row_taxrate)+currentRow] = {
        v:'8%消費税',t:'s',w:'8%消費税',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{
            bold:true,
            sz:labelFontSize,
            name:familyname,
          },
          alignment:{
            horizontal:'center',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_unitprice)+currentRow] = {
        v:count_taxType1+'点',t:'s',w:count_taxType1+'点',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } ,
          font:{ sz:fontSize,name:familyname,},
          alignment:{
            horizontal:'right',
          },
        }
      }
      worksheet[xlsx.utils.encode_col(Row_sum)+currentRow] = {
        v:sum_taxType1,t:'n',w:sum_taxType1,z:'#,##0',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{ sz:fontSize,name:familyname,},
        }
      }
      currentRow++;
      currentRow++;

      //合計金額
      worksheet[xlsx.utils.encode_col(Row_unitprice)+currentRow] = {
        v:'合計金額',t:'s',w:'合計金額',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } ,
          font:{
            bold:true,
            sz:labelFontSize,
            name:familyname,
          },
          alignment:{
            horizontal:'center',
          },
        }
      }
      const sum = sum_priceType0+sum_priceType1+sum_taxType0+sum_taxType1
      worksheet[xlsx.utils.encode_col(Row_sum)+currentRow] = {
        v:sum,t:'n',w:sum,z:'#,##0',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } },
          font:{ sz:fontSize,name:familyname,}, 
        }
      }

      worksheet['!cols'] = [{wch:1.5},{wch:25},{wch:25},{wch:30},{wch:10},{wch:10},{wch:13.5},{wch:13.5},{wch:13.5},{wch:1.5},]
      pickingSheet['!cols'] = worksheet['!cols']

      const rows:any = [{hpx:15.75},{hpx:42},{hpx:15.75}]
      for(let i = 2; i < currentRow;i++){
        rows.push({hpx:33})
      }

      worksheet['!rows'] = rows
      pickingSheet['!rows'] = rows
      pickingSheet['!rows'][1].hpx = 42


      //表示範囲を設定.これを入れないとデータを入れても表示されない
      const ref = "A1:"+ xlsx.utils.encode_col(10) + currentRow;
      worksheet['!ref'] = ref
      pickingSheet['!ref'] = "A1:"+ xlsx.utils.encode_col(10) + pickingRow;

      //複製して納品書配送車控を作成
      const customerSheet = JSON.parse(JSON.stringify(worksheet))
      customerSheet["!merges"] = merge;

      //配送車用の各情報を記入
      {
        //納品書(配送車控)の文字を記入
        worksheet[xlsx.utils.encode_col(baseColumn)+startRow] = {
          v:'納品書(配送車控)',t:'s',w:'納品書(配送車控)',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
              left:{style:'thick', color:{ rgb: grayFrame }},
              bottom:{style:'thick', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:24,
              name:familyname,
            },
            alignment: { vertical:'center', }
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+1)+(startRow-1)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              bottom:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+1)+(startRow+1)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+2)+(startRow)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              left:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }

        //サイン欄を作成
        merge.push({ s: { r: customerMessageStartRow-1, c: baseColumn+6 }, e: { r: customerMessageStartRow-1, c: baseColumn+7 } })
        worksheet["!merges"] = merge;

        worksheet[xlsx.utils.encode_col(baseColumn+6)+customerMessageStartRow ] = {
          v:'お客様サイン',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+7)+customerMessageStartRow ] = {
          v:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+6)+(customerMessageStartRow+1)] = {
          v:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+7)+(customerMessageStartRow+1)] = {
          v:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+6)+(customerMessageStartRow+2)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+7)+(customerMessageStartRow+2)] = {
          v:'',
          s:{
            border:{
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+6)+(customerMessageStartRow+3)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        worksheet[xlsx.utils.encode_col(baseColumn+7)+(customerMessageStartRow+3)] = {
          v:'',
          s:{
            border:{
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
      }

      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook,worksheet,"納品書配送車控")

      {
        ////納品書兼領収書の文字を記入
        customerSheet[xlsx.utils.encode_col(baseColumn)+startRow] = {
          v:'納品書 兼 領収書(お客様用)',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
              left:{style:'thick', color:{ rgb: grayFrame }},
              bottom:{style:'thick', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            font:{
              bold:true,
              sz:24,
              name:familyname,
            },
            alignment: { vertical:'center', }
          }
        }

        customerSheet[xlsx.utils.encode_col(baseColumn+1)+(startRow-1)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              bottom:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }
        customerSheet[xlsx.utils.encode_col(baseColumn+1)+(startRow+1)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }
        customerSheet[xlsx.utils.encode_col(baseColumn+2)+(startRow)] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              left:{style:'thick', color:{ rgb: grayFrame }},
            },
          }
        }
        


        //客用のメッセージを記入

        customerSheet[xlsx.utils.encode_col(baseColumn)+customerMessageStartRow ] = {
          v:'このたびはお買い上げいただきありがとうございます。',
          s:{font:{ sz:18,name:familyname,},}
        }
        customerSheet[xlsx.utils.encode_col(baseColumn)+(customerMessageStartRow+1) ] = {
          v:'下記、正に領収いたしました。',
          s:{font:{ sz:18,name:familyname,},}
        }
        customerSheet[xlsx.utils.encode_col(baseColumn)+(customerMessageStartRow+2) ] = {
          v:'(お支払い方法：         クレジットカード           )',
          s:{font:{ sz:18,name:familyname,},}
        }
      }

      //workbookに保存
      xlsx.utils.book_append_sheet(workbook,customerSheet,"納品書兼領収書")

      //受注明細用の各情報を記入
      {
        //納品書(配送車控)の文字を記入
        pickingSheet[xlsx.utils.encode_col(baseColumn)+startRow] = {
          v:'受注明細（店内ピッキング・パッキング用）',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
              left:{style:'thick', color:{ rgb: grayFrame }},
              bottom:{style:'thick', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: whiteFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } ,
            font:{
              bold:true,
              sz:24,
              name:familyname,
            },
            alignment: { vertical:'center', }
          }
        }

        pickingSheet[xlsx.utils.encode_col(baseColumn+1)+(startRow-1)] = {
          v:'',
          s:{
            border:{
              bottom:{style:'thick', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+1)+(startRow+1)] = {
          v:'',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+2)+(startRow-1)] = {
          v:'',
          s:{
            border:{
              bottom:{style:'thick', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+2)+(startRow+1)] = {
          v:'',
          s:{
            border:{
              top:{style:'thick', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }

        pickingSheet[xlsx.utils.encode_col(baseColumn+3)+(startRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thick', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }

        for(let i = 0;i <= 3; i++){
          pickingSheet[xlsx.utils.encode_col(baseColumn+4+i)+(startRow+1)] = {
            v:'',
            s:{
              border:{
                left:null,
                right:null,
                top:null,
                bottom:null,
              }, 
            }
          }
        }

        pickingSheet[xlsx.utils.encode_col(baseColumn+4)+(startRow)] = {
          v:'検品\nピッキング',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment: { wrapText: true,vertical:'center', }
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+5)+(startRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+6)+(startRow)] = {
          v:'検品\nパッキング',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment: { wrapText: true,vertical:'center', }
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+7)+(startRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }

        pickingRow = startRow + 2
        for(let i = 0;i <= 3; i++){
          pickingSheet[xlsx.utils.encode_col(baseColumn+4+i)+(pickingRow)] = {
            v:'',
            s:{
              border:{
                left:null,
                right:null,
                top:null,
                bottom:null,
              }, 
            }
          }
        }
        pickingRow++
        pickingSheet[xlsx.utils.encode_col(baseColumn+4)+(pickingRow)] = {v:'',}
        pickingSheet[xlsx.utils.encode_col(baseColumn+4)+(pickingRow+1)] = {v:'',}
        pickingSheet[xlsx.utils.encode_col(baseColumn+4)+(pickingRow+2)] = {v:'',}
        pickingSheet[xlsx.utils.encode_col(baseColumn+4)+(pickingRow+3)] = {v:'',}

        pickingSheet[xlsx.utils.encode_col(baseColumn+5)+(pickingRow)] = {
          v:'お届け小口数',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:null,
            },
            font:{
              bold:true,
              sz:labelFontSize,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+6)+(pickingRow)] = {
          v:'オリコン',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:14,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+7)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingRow++

        pickingSheet[xlsx.utils.encode_col(baseColumn+5)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:null,
              bottom:null,
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+6)+(pickingRow)] = {
          v:'ケース',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:14,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+7)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }

        pickingRow++

        pickingSheet[xlsx.utils.encode_col(baseColumn+5)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:null,
              bottom:null,
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+6)+(pickingRow)] = {
          v:'その他',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:14,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+7)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }

        pickingRow++

        pickingSheet[xlsx.utils.encode_col(baseColumn+5)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:null,
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+6)+(pickingRow)] = {
          v:'計',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            },
            font:{
              bold:true,
              sz:14,
              name:familyname,
            },
            alignment:{
              horizontal:'center',
            },
          }
        }
        pickingSheet[xlsx.utils.encode_col(baseColumn+7)+(pickingRow)] = {
          v:'',
          s:{
            border:{
              left:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
              top:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
            }, 
          }
        }



      }

      xlsx.utils.book_append_sheet(workbook,pickingSheet,"受注明細")

      /*
      const baseColumn = 2; //起点とするカラム
      const checkColumn = 1; //チェックボックスを付けるカラム
      const labelColumn = 3; //(伝票番号)等を書くカラム
      const startRow = 2;
      let currentRow = startRow;

      

      //冒頭に客の住所、氏名を書き出し、その下に商品名と数量、小計価格を1行とし、最終行に合計金額を記載
      //各行の左端にチェックを書き込めるようなスペースを四角で
      //小口数（１/３等の表記）を書き込めるスペースを開けて

      //記入を開始
      const worksheet = xlsx.utils.json_to_sheet([])

      //店舗情報
      const shop = shopDataSource.value.filter((e:any)=>e.code==receipt.shopcode)[0]
      const shopname = shop.label
      const invoice = shop.detail.invoice
      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'提供店舗',t:'s',w:'提供店舗',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:shopname,t:'s',w:shopname,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'インボイス番号',t:'s',w:'インボイス番号',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:invoice,t:'s',w:invoice,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      //伝票番号
      let receiptNo = receipt.no
      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'伝票番号',t:'s',w:'伝票番号',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:receiptNo,t:'s',w:receiptNo,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'注文日時',t:'s',w:'注文日時',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:receipt.creationdate,t:'s',w:receipt.creationdate,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      currentRow++;

      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'希望日時',t:'s',w:'希望日時',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:receipt.estimateddeliverydate,t:'s',w:receipt.estimateddeliverydate,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      currentRow++;

      worksheet[xlsx.utils.encode_col(labelColumn)+currentRow] = {
        v:'発行日',t:'s',w:'発行日',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      const dateIssue = dayjs().format('YYYY年MM月DD日')
      worksheet[xlsx.utils.encode_col(labelColumn+1)+currentRow] = {
        v:dateIssue,t:'s',w:dateIssue,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      currentRow++;

      //郵便番号
      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:receipt.postcode,t:'s',w:receipt.postcode,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      //氏名
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'氏名',t:'s',w:'氏名',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:name+' 様',t:'s',w:name+' 様',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      
      currentRow++;

      //住所
      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:address,t:'s',w:address,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      //氏名カナ
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'氏名カナ',t:'s',w:'氏名カナ',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:namekana+' ｻﾏ',t:'s',w:namekana+' ｻﾏ',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      currentRow++;
      currentRow++;
      
      //ヘッダ
      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'商品名',t:'s',w:'商品名',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'数量',t:'s',w:'数量',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:'小計',t:'s',w:'小計',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+3)+currentRow] = {
        v:'分類',t:'s',w:'分類',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
        v:'JANコード/POSコード',t:'s',w:'JANコード/POSコード',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+5)+currentRow] = {
        v:'インストアコード',t:'s',w:'インストアコード',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      currentRow++;

      let sum = 0;
      let sum_type_0 = 0
      let sum_type_1 = 0
      let tax_sum_0 = 0
      let tax_sum_1 = 0

      receipt.details.forEach((commodity:any) => {
        console.log('receipt.details',commodity)
        let isCoupon = false
        //チェックボックスを書く
        if(commodity.unitprice > 0){
          worksheet[xlsx.utils.encode_col(baseColumn-1)+currentRow] = {
            v:'',t:'s',w:'',
            s:{
              border:{
                top:{style:'double', color:{ rgb: blackFrame }},
                left:{style:'double', color:{ rgb: blackFrame }},
                bottom:{style:'double', color:{ rgb: blackFrame }},
                right:{style:'double', color:{ rgb: blackFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }

          let pick='常温'
          try{
            const json = JSON.parse(commodity.commoditydetail)
            if(json.pick==1) pick='ﾁﾙﾄﾞ'
            if(json.pick==2) pick='冷蔵'
          } catch{
            //
          }
          worksheet[xlsx.utils.encode_col(baseColumn+3)+currentRow] = {
            v:pick,t:'s',w:pick,
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
          
        } else {
          isCoupon = true
          worksheet[xlsx.utils.encode_col(baseColumn+3)+currentRow] = {
            v:'ｸｰﾎﾟﾝ',t:'s',w:'ｸｰﾎﾟﾝ',
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
        }
        

        worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
          v:commodity.name,t:'s',w:commodity.name,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }

        worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
          v:commodity.count,t:'s',w:commodity.count,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: whiteFrame } } 
          }
        }

        //const subtotal =  Math.floor( commodity.unitprice * commodity.count * (1 + commodity.taxrate)) 
        //sum += subtotal
        const subtotal =  Math.floor( commodity.unitprice * commodity.count) 
        const taxtypecheck =  Math.floor( commodity.taxrate * 100)
        const taxPrice =  Math.floor( subtotal * (taxtypecheck / 100))
        sum += Math.floor( subtotal * (1 + (taxtypecheck / 100)))
        if(taxtypecheck == 10){
          sum_type_0 += subtotal
          tax_sum_0 += Math.floor( subtotal *  commodity.taxrate)
        } else {
          sum_type_1 += subtotal
          tax_sum_1 += Math.floor( subtotal *  commodity.taxrate)
        }
        if(isCoupon){
          const couponPrice = subtotal + taxPrice
          worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
            v:couponPrice,t:'s',w:couponPrice,
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
        } else {
          worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
            v:subtotal,t:'s',w:subtotal,
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }

          
          try{
            const json = JSON.parse(commodity.commoditydetail)
            worksheet[xlsx.utils.encode_col(baseColumn+4)+currentRow] = {
            v:json.poscode,t:'s',w:json.poscode,
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
          } catch {
            //
          }

          try{
            const realcode = getRealcode(commodity.commoditycode)
            worksheet[xlsx.utils.encode_col(baseColumn+5)+currentRow] = {
              v:realcode,t:'s',w:realcode,
              s:{
                border:{
                  top:{style:'thin', color:{ rgb: grayFrame }},
                  left:{style:'thin', color:{ rgb: grayFrame }},
                  bottom:{style:'thin', color:{ rgb: grayFrame }},
                  right:{style:'thin', color:{ rgb: grayFrame }},
                },
                fill: { fgColor: { rgb: whiteFrame } } 
              }
            } 
          } catch {
            //
          }

          currentRow++;
          worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
            v:'消費税',t:'s',w:'消費税',
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
          worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
            v:'',t:'s',w:'',
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }
          worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
            v:taxPrice,t:'s',w:taxPrice,
            s:{
              border:{
                top:{style:'thin', color:{ rgb: grayFrame }},
                left:{style:'thin', color:{ rgb: grayFrame }},
                bottom:{style:'thin', color:{ rgb: grayFrame }},
                right:{style:'thin', color:{ rgb: grayFrame }},
              },
              fill: { fgColor: { rgb: whiteFrame } } 
            }
          }

        }

        currentRow++;
      });



      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'合計',t:'s',w:'合計',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:sum,t:'s',w:sum,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      currentRow++;
      currentRow++;
      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'内訳',t:'s',w:'内訳',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      currentRow++;

      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'税率10%',t:'s',w:'税率10%',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb:whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:sum_type_0,t:'s',w:sum_type_0,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'消費税(10%)',t:'s',w:'消費税(10%)',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:tax_sum_0,t:'s',w:tax_sum_0,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'税率8%',t:'s',w:'税率8%',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:sum_type_1,t:'s',w:sum_type_1,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      currentRow++;

      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'消費税(8%)',t:'s',w:'消費税(8%)',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }
      worksheet[xlsx.utils.encode_col(baseColumn+1)+currentRow] = {
        v:'',t:'s',w:'',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }

      worksheet[xlsx.utils.encode_col(baseColumn+2)+currentRow] = {
        v:tax_sum_1,t:'s',w:tax_sum_1,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: whiteFrame } } 
        }
      }


      worksheet['!cols'] = [{wch:1.35},{wch:2.35},{wch:31.75},{wch:15},{wch:20},{wch:5},{wch:20},{wch:20},{wch:1.35},]

      //表示範囲を設定.これを入れないとデータを入れても表示されない
      const ref = "A1:"+ xlsx.utils.encode_col(7) + currentRow;
      worksheet['!ref'] = ref
      

      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook,worksheet,"伝票")
      */
      let sheetname = '伝票'+receipt.no
      xlsx.writeFile(workbook,sheetname+".xlsx", { compression: true });
    }

    const getRealcode = (commoditycode:string) => {
      const tmp = commodityDataSource.value.filter((e:any)=>e.code==commoditycode)
      if(tmp.length > 0) return tmp[0].realcode
      return null
    }

    const receiptOK = async() => {
        loading.value = true
        try{
          const res = await axios.post(Constains.baseURL+'/selectundispatched',JSON.stringify(receiptData.value),{headers:{
                //'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          if(res.status == 200){
            notification.success({message:'配送準備の登録完了.'})
            receiptVisible.value = false
            await receiptReload()
          }
        } catch(e){
          console.log(e)
        }
        loading.value = false
    }

    const shopVisible = ref(false)
    const shopData:any = ref({ })

    const shopEditOpen = (shop:any) => {
      if(shop==null){
        shopData.value.code = null
        shopData.value.name = null
        shopData.value.detail = {color:null,sort:null,invoice: null,address:null,tel:null,}
        shopData.value.taxcalctype = null
        shopData.value.taxfrac = null
        shopData.value.pointcardcode = null
        shopData.value.pointcardrate = 0
        shopData.value.editable = true
        shopData.value.new = true
        shopData.value.adminData = {}
      } else {
        shopData.value.code = shop.code
        shopData.value.name = shop.name
        shopData.value.detail = shop.detail
        shopData.value.taxcalctype = shop.taxcalctype
        shopData.value.taxfrac = shop.taxfrac
        shopData.value.editable = shop.editable
        shopData.value.pointcardcode = shop.pointcardcode
        shopData.value.pointcardrate = shop.pointcardrate
        shopData.value.new = false
        shopData.value.adminData = null
      } 
      shopVisible.value = true
    }

    const shopOK = async() => {
      const shopcode = cookies.cookies.get('shopcode')
      if(!shopData.value.editable) {
        shopVisible.value = false
        return
      }
      shopData.value.shopcode = shopcode
      if(shopData.value.new){
        await shopAdd(shopData.value)
      } else {
        await shopEdit(shopData.value)
      }
      shopVisible.value = false
    }

    var taxfrac = 0

    const shopReload = async() => {
        shopDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        try{
          const res = await axios.get(Constains.managementURL+'/api/shop/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          if(res.status == 200){
            const data = res.data
            data.forEach((shop:any) => {
              if(shop.detail=='') shop.detail = {color:''}
              else shop.detail = JSON.parse(shop.detail)
              shop.label = shop.name
              shop.value = shop.code
              shopDataSource.value.push(shop)
              if(shopcode == shop.code){
                taxfrac = shop.taxfrac
              }
              shop.editable = shop.code == shopcode
            });
            shopDataSource.value.sort((a:any,b:any)=>{
              return a.detail.sort - b.detail.sort;
            })
          }
          loading.value = false
        } catch (e:any) {
          console.log(e)
          if(e.response.status == 400) {
            //トークンが無効なのでログアウト
            console.log("トークンが無効なのでログアウト")
            cookies.cookies.remove('token');
            cookies.cookies.remove('shopcode');
            router.push("/login")
          }
        }
        
    }

    const shopAdd = async(shop:any) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      if(!shop.adminData.code || !shop.adminData.password){
        notification.error({message:'最初の管理者用の情報を入力してください'})
        return
      }
      const json:any = {
        shopcode:shopcode,
        code:shop.code,
        name:shop.name,
        detail:JSON.stringify(shop.detail),
        taxcalctype:0,
        taxfrac:0,
        pointcardcode:'',
        pointcardrate:0,
      }
      loading.value = true
      try{
        const res = await axios.post(Constains.managementURL+'/api/shop',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          const admin = shop.adminData
          admin.shopcode = shopcode
          admin.scode = shop.code
          await adminAdd(admin)
          await shopReload()
        }
      }catch(e){
        loading.value =false
        console.log(e)
      }
      
    }

    const shopEdit = async(shop:any) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      const json:any = {
        shopcode:shopcode,
        code:shop.code,
        name:shop.name,
        detail:JSON.stringify(shop.detail),
        taxcalctype:shop.taxcalctype,
        taxfrac:shop.taxfrac,
        pointcardcode:shop.pointcardcode,
        pointcardrate:shop.pointcardrate,
      }

      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/shop',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await shopReload()
      }
    }

    const shopDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/shop?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await shopReload()
      }
    }

    const getTaxPrice = (record:any) => {
      const tax = record.taxtype == 0 ? 1.1 :1.08
      const price = record.unitprice * tax
      if(taxfrac == 0) {
        return Math.floor(price)
      } else if(taxfrac == 1){
        return Math.ceil(price)
      } else if(taxfrac == 2){
        return Math.round(price)
      } else {
        return price
      }
    }

    const getDetailRecord = (record:any) => {
      let text = ""
      if(record.detail){
        const json = JSON.parse(record.detail)
        if(json.detail){
          json.detail.forEach((item:any) => {
          text += item.label+":"+item.value+"<br>"
        });
        }
      }
      return text
    }

    const getDeliveryColumnsPOSJANCode = (record:any) => {
      try{
        const json = JSON.parse(record.commoditydetail)
        return json.poscode
      } catch {
        return ''
      }
    }

    const getDeliveryColumnsPickType = (record:any) => {
      if(record.unitprice < 0) return 'クーポン'
      try{
        const json = JSON.parse(record.commoditydetail)
        if(json.pick == 1) return 'チルド'
        if(json.pick == 2) return '冷凍'
        return '常温'
      } catch {
        return '常温'
      }
    }

    const getPOSJANCode = (record:any) => {
      if(record.detail){
        const json = JSON.parse(record.detail)
        if(json.detail){
          return json.poscode
        }
      }
      return null
    }

    const getPointCardCode = (record:any) => {
      let text = ""
      if(record.pointcardcode){
        try{
          const json = JSON.parse(record.pointcardcode)
          Object.keys(json).forEach((key:any) => {
            const tmp = shopDataSource.value.filter((e:any)=>e.code==key)
            if(tmp.length > 0) text += tmp[0].name+":"+json[key]+"<br>"
          });
          return text
        } catch(e) {
          return record.pointcardcode
        }
      }
    }

    const prepareDeliveryColumns = [
      {
        title:'No',
        dataIndex:'numbering'
      },
      {
        title:'伝票番号',
        dataIndex:'no',
      },
      {
        title:'LINE-ID',
        dataIndex:'lineid',
        width:'150px',
      },
      {
        title:'お名前',
        dataIndex:'name',
        children:[
          {
            title: '姓',
            dataIndex: 'sei',
          },
          {
            title: '名',
            dataIndex: 'mei',
          },
          {
            title: 'セイ',
            dataIndex: 'seikana',
          },
          {
            title: 'メイ',
            dataIndex: 'meikana',
          },
        ]
      },
      {
        title:'郵便番号',
        dataIndex:'postcode',
      },
      {
        title:'ご住所(お届け先)',
        children:[
        {
            title: '都道府県',
            dataIndex: 'prefecture',
          },
          {
            title: '市区町村',
            dataIndex: 'city',
          },
          {
            title: '地名番名',
            dataIndex: 'town',
          },
          {
            title: '建物名',
            dataIndex: 'building',
          },
        ]
      },
      {
        title:'配達希望時間',
        dataIndex:'estimateddeliverydate',
      },
      {
        title:'状況',
        dataIndex:'state',
      },
      {
        title:'操作',
        dataIndex:'operation',
        width:'200px',
      },
    ]

    const orderSummaryColumns = [
      {
        title:'伝票番号',
        dataIndex:'no',
      },
      {
        title:'LINE-ID',
        dataIndex:'lineid',
      },
      {
        title:'お名前',
        dataIndex:'name',
        children:[
          {
            title: '姓',
            dataIndex: 'sei',
          },
          {
            title: '名',
            dataIndex: 'mei',
          },
          {
            title: 'セイ',
            dataIndex: 'seikana',
          },
          {
            title: 'メイ',
            dataIndex: 'meikana',
          },
        ]
      },
      {
        title:'JAN・POSコード',
        dataIndex:'poscode',
        sorter:(a:any,b:any) => a.poscode.localeCompare(b.poscode, 'ja'),
      },
      {
        title:'インストアコード',
        dataIndex:'realcode',
        sorter:(a:any,b:any) => a.realcode.localeCompare(b.realcode, 'ja'),
      },
      {
        title:'商品名',
        dataIndex:'name',
        sorter:(a:any,b:any) => a.name.localeCompare(b.name, 'ja'),
      },
      {
        title:'個数',
        dataIndex:'count',
      },
      {
        title:'分類',
        dataIndex:'pick',
      },
      {
        title:'欠品',
        dataIndex:'lost',
      },
      {
        title:'配達希望時間',
        dataIndex:'estimateddeliverydate',
      },
    ]

    const OrderSummaryDataSource:any = ref([])

    const getOrderSummaryDataSource = () => {
      const dataSource:any = []
      const tmp = receiptDataSource.value.filter((e:any)=>e.state != 255)
      tmp.forEach((receipt:any) => {
        const details = receipt.details
        details.forEach((commodity:any) => {
          if(commodity.unitprice > 0) {
            let push = receipt
            //let lost = false
            push.name = commodity.name
            push.count = commodity.count
            try{
              const json = JSON.parse(commodity.commoditydetail)
              push.pick = json.pick
              push.poscode = json.poscode
            }catch{
              //
            }
            try{
              const comTmp = commodityDataSource.value.filter((e:any)=>e.code==commodity.commoditycode)
              if(comTmp.length > 0){
                const commodityDetail = comTmp[0]
                push.realcode = commodityDetail.realcode
              }
                //lost = commodityDetail.stock < commodity.count //注文時点で欠品かどうかは不明
            } catch {
              //
            }
            /*
            const comTmp = commodityDataSource.value.filter((e:any)=>e.code==commodity.commoditycode)
            if(comTmp.length > 0){
              const commodityDetail = comTmp[0]
              push.realcode = commodityDetail.realcode
              //lost = commodityDetail.stock < commodity.count //注文時点で欠品かどうかは不明
              try{
                const d = JSON.parse(commodityDetail.detail)
                push.poscode = d.poscode
              }catch{
                //
              }
            } else {
              lost = true
            }
            push.lost = lost
            */
            if(push.realcode == null) push.realcode = ""
            if(push.poscode == null) push.poscode = ""
            dataSource.push(push)
          }
          
        });
      });
      return dataSource
    }

    const saleonly = ref(false)

    const saleonlyChange = () => {
      if(saleonly.value) commodityDataSourceIsSale.value = commodityDataSource.value.filter((e:any)=>e.issale)
      else commodityDataSourceIsSale.value = commodityDataSource.value
    }

    const salealldelete = async() => {
      const list = commodityDataSource.value.filter((e:any)=>e.issale)
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      list.forEach(async(item:any) => {
        await axios.delete(Constains.managementURL+'/api/commodity?shopcode='+shopcode+'&code='+item.code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      });

      saleonly.value = false
      await commodityReload()
      loading.value = false
    }

    const couponColumns = [
        {
            title:'クーポンコード',
            dataIndex:'code',
        },
        {
            title:'クーポン名',
            dataIndex:'name',
        },
        {
            title:'商品名',
            dataIndex:'commodityname',
        },
        {
            title:'商品コード',
            dataIndex:'receiptcode',
        },
        {
          title:'詳細',
          dataIndex:'detail',
        },
        {
            title:'値引率',
            dataIndex:'rate',
        },
        {
            title:'回数',
            dataIndex:'count',
        },
        {
            title:'種類',
            dataIndex:'type',
        },
        {
            title:'開始日',
            dataIndex:'start',
        },
        {
            title:'終了日',
            dataIndex:'end',
        },
        {
            title:'アクティベート',
            dataIndex:'actived',
        },
        {
            title:'操作',
            dataIndex:'operation',
            width:'100px'
        },
    ]
    const couponDataSource:any = ref([])

    const couponVisible = ref(false)
    const couponData:any = ref({ })

    const couponEditOpen = (coupon:any,commodity:any) => {
      if(coupon==null){
        const commodityDetail = JSON.parse(commodity.detail)

        couponData.value.code = ''
        couponData.value.name = null
        couponData.value.detail = 0
        couponData.value.commoditycode = commodity.code
        couponData.value.receiptcode = commodityDetail.poscode
        couponData.value.rate = null
        couponData.value.count = 1
        couponData.value.start  = dayjs()
        couponData.value.end = dayjs().add(1, 'y')
        couponData.value.actived = true

        couponData.value.new = true
      } else {
        couponData.value.code = coupon.code
        couponData.value.name = coupon.name
        couponData.value.detail = coupon.detail
        couponData.value.commoditycode = coupon.commoditycode
        couponData.value.receiptcode = coupon.receiptcode
        couponData.value.rate = coupon.rate
        couponData.value.count = coupon.count
        couponData.value.countperonce = coupon.count
        couponData.value.start = coupon.start === null ? null : dayjs(coupon.start)
        couponData.value.end = coupon.end === null ? null : dayjs(coupon.end)
        couponData.value.actived = coupon.actived

        couponData.value.new = false
      } 
      couponVisible.value = true
    }

    const couponOK = async() => {
      if(couponData.value.new){
        couponData.value.countperonce = couponData.value.count
        await couponAdd(couponData.value)
      } else {
        //await couponEdit(couponData.value)
      }
      couponVisible.value = false
    }

    const couponReload = async() => {
        couponDataSource.value = []
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        try{
          const res = await axios.get(Constains.managementURL+'/api/coupon/list?shopcode='+shopcode,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          if(res.status == 200){
            const data = res.data
            const now = dayjs()
            data.forEach((coupon:any) => {
              const end = dayjs(coupon.end)
              if(coupon.actived) coupon.actived = now.isBefore(end)
              if(coupon.detail=='{}')coupon.detail=0
              couponDataSource.value.push(coupon)
            });
          }
          couponDataSource.value.sort((a:any,b:any)=>{
            const a_day = dayjs(a.start)
            const b_day = dayjs(b.start)
            return a_day.isAfter(b_day) ? 1 : -1;
          })
          
          couponDataSource.value.sort((a:any,b:any)=>{
            if(a.actived || b.actived ) return -1
            return 0
          })
          loading.value = false
        } catch (e:any) {
          console.log(e)
          if(e.response.status == 400) {
            //トークンが無効なのでログアウト
            console.log("トークンが無効なのでログアウト")
            cookies.cookies.remove('token');
            cookies.cookies.remove('couponcode');
            router.push("/login")
          }
        }
        
    }

    const couponAdd = async(coupon:any) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')

      const json = JSON.parse(JSON.stringify(coupon))
      json.start = coupon.start.format('YYYY/MM/DD')
      json.end = coupon.end.format('YYYY/MM/DD')
      json.detail = JSON.stringify(coupon.detail)
      json.scode = shopcode
      json.shopcode = shopcode

      loading.value = true
      try{
        const res = await axios.post(Constains.managementURL+'/api/coupon',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
        if(res.status == 200){
          await couponReload()
        }
      }catch(e){
        loading.value =false
        //console.log(e)
        notification.error({
          message:'有効期限が不正です'
        })
      }
      
      couponVisible.value = false
      
    }

    const couponEdit = async(coupon:any) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      const json:any = {

      }

      loading.value = true
      const res = await axios.put(Constains.managementURL+'/api/coupon',JSON.stringify(json),{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await couponReload()
      }
    }

    const couponDelete = async(code:string) => {
      const token = cookies.cookies.get('token')
      const shopcode = cookies.cookies.get('shopcode')
      loading.value = true
      const res = await axios.delete(Constains.managementURL+'/api/coupon?shopcode='+shopcode+'&code='+code,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
      if(res.status == 200){
        await couponReload()
      }
    }

    const couponcommodityDetail = (coupon:any) => {
      const commodityFilter = commodityDataSource.value.filter((e:any)=>e.code==coupon.commoditycode)
      if(commodityFilter.count == 0) {
        notification.error({
          message:'該当する商品は存在しません'
        })
        return
      }
      const commodity = commodityFilter[0]
      commodityEditOpen(commodity)
    }

    const spreadsheetSelectDay:any = ref(null)
    const spreadsheetCount:any = ref(0)
    const spreadsheetSum:any = ref(0)
    let spreadsheetgetDay:any = null

    const spreadsheetColumns = [
        {
            title:'JANコード・POSコード',
            dataIndex:'poscode',
        },
        {
            title:'商品名',
            dataIndex:'name',
        },
        {
            title:'税抜売価',
            dataIndex:'unitprice',
            width:'100px'
        },
        {
            title:'税込売価',
            dataIndex:'taxprice',
            width:'100px'
        },
        {
            title:'セール表示',
            dataIndex:'issale',
            width:'100px'
        },
        {
            title:'商品カテゴリ',
            dataIndex:'categorycode',
        },
        {
            title:'インストアコード',
            dataIndex:'realcode',
            width:'170px'
        },
        {
            title:'分類',
            dataIndex:'pick',
            width:'70px'
        },
        {
          title:'販売数',
          dataIndex:'count',
        },
        {
          title:'販売額',
          dataIndex:'sumprice',
        }
    ]
    const spreadsheetDataSource:any = ref([])

    const getSpreadsheet = async() => {
        spreadsheetDataSource.value = []
        spreadsheetgetDay = spreadsheetSelectDay.value
        spreadsheetCount.value = 0
        spreadsheetSum.value = 0
        const start = spreadsheetSelectDay.value.format('YYYY/MM/DD')
        const end = start
        const token = cookies.cookies.get('token')
        const shopcode = cookies.cookies.get('shopcode')
        loading.value = true
        try{
          const res = await axios.get(Constains.managementURL+'/api/receipt/totalize?shopcode='+shopcode+'&start='+start+'&end='+end,{headers:{
                'Authorization':'Bearer '+token,
                'Content-Type': 'application/json',
                }});
          if(res.status == 200){
            const data = res.data
            data.forEach((item:any) => {
              const taxrate = Math.ceil(item.taxrate * 100) /100
              const push = {
                poscode:'',
                name:item.name,
                unitprice:item.unitprice,
                taxprice:Math.floor(item.unitprice * (1+taxrate)),
                issale:'',
                categorycode:'',
                realcode:'',
                pick:'',
                count:item.count,
                sumprice:Math.floor(item.unitprice * (1+taxrate))*item.count,
              }
              spreadsheetCount.value += push.count
              spreadsheetSum.value += push.sumprice

              try{
                const detail = JSON.parse(item.commodity.detail)
                push.poscode = detail.poscode
                if(detail.issale) push.issale = 'セール表示'
                {
                  const tmp = categoryDataSource.value.filter((e:any)=>e.code==item.commodity.categorycode)
                  if(tmp.length > 0) {
                    let parent = tmp[0].parentcode
                    push.categorycode = tmp[0].label
                    while(parent != null){
                      const t = categoryDataSource.value.filter((e:any)=>e.code==parent)
                      if(t.length > 0){
                        parent = t[0].parentcode
                        push.categorycode = t[0].label+'→'+push.categorycode
                      } else {
                        break
                      }
                    }
                  }
                }
                
                push.realcode = item.commodity.realcode
                if(detail.pick == 0) push.pick = '常温'
                else if(detail.pick == 1) push.pick = 'チルド'
                else if(detail.pick == 2) push.pick = '冷凍'
              } catch(e){
                //
              }
              spreadsheetDataSource.value.push(push)
            });
          }

          loading.value = false
        } catch (e:any) {
          console.log(e)
          loading.value = false
        }
    }

    const downloadSpreadsheet = () => {
      const whiteFrame = 'FFFFFF'
      const blackFrame = '000000'
      const lightgrayFrame = 'd3d3d3'
      const grayFrame = '808080'
      const headerColor = '9cd4ac'

      const baseColumn = 0; //起点とするカラム
      const startRow = 1;
      let currentRow = startRow;
      let currentColumn = baseColumn

      let sum = 0;
      let saleCount = 0;

      //記入を開始
      const worksheet = xlsx.utils.json_to_sheet([])

      //ヘッダを記入
      spreadsheetColumns.forEach((column:any)=> {
        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:column.title,t:'s',w:column.title,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: headerColor } } 
          }
        }
        currentColumn++
      })
      currentRow++

      //中身を記入
      spreadsheetDataSource.value.forEach((proceeds:any)=>{
        currentColumn = baseColumn
        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.poscode,t:'s',w:proceeds.poscode,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.name,t:'s',w:proceeds.name,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.unitprice,t:'s',w:proceeds.unitprice,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.taxprice,t:'s',w:proceeds.taxprice,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.issale,t:'s',w:proceeds.issale,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.categorycode,t:'s',w:proceeds.categorycode,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.realcode,t:'s',w:proceeds.realcode,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.pick,t:'s',w:proceeds.pick,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.count,t:'s',w:proceeds.count,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }
        currentColumn++

        worksheet[xlsx.utils.encode_col(currentColumn)+currentRow] = {
          v:proceeds.sumprice,t:'s',w:proceeds.sumprice,
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
          }
        }

        saleCount += proceeds.count
        sum += proceeds.sumprice

        currentRow++
          
      })

      currentColumn = baseColumn
      
      currentRow++

      //合計を記入
      worksheet[xlsx.utils.encode_col(baseColumn)+currentRow] = {
        v:'総額',t:'s',w:'総額',
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      currentColumn++

      for(let i = currentColumn;i<8;i++){
        worksheet[xlsx.utils.encode_col(i)+currentRow] = {
          v:'',t:'s',w:'',
          s:{
            border:{
              top:{style:'thin', color:{ rgb: grayFrame }},
              left:{style:'thin', color:{ rgb: grayFrame }},
              bottom:{style:'thin', color:{ rgb: grayFrame }},
              right:{style:'thin', color:{ rgb: grayFrame }},
            },
            fill: { fgColor: { rgb: headerColor } } 
          }
        }
      }

      const saleColumn = spreadsheetColumns.findIndex((e:any)=>e.dataIndex=='count')
      worksheet[xlsx.utils.encode_col(baseColumn+saleColumn)+currentRow] = {
        v:saleCount,t:'s',w:saleCount,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      const sumColumn = spreadsheetColumns.findIndex((e:any)=>e.dataIndex =='sumprice')
      worksheet[xlsx.utils.encode_col(baseColumn+sumColumn)+currentRow] = {
        v:sum,t:'s',w:sum,
        s:{
          border:{
            top:{style:'thin', color:{ rgb: grayFrame }},
            left:{style:'thin', color:{ rgb: grayFrame }},
            bottom:{style:'thin', color:{ rgb: grayFrame }},
            right:{style:'thin', color:{ rgb: grayFrame }},
          },
          fill: { fgColor: { rgb: headerColor } } 
        }
      }

      worksheet['!cols'] = [{wch:20},{wch:20},{wch:10},{wch:10},{wch:10},{wch:25},{wch:20},{wch:10},{wch:10},{wch:10},]

      //表示範囲を設定.これを入れないとデータを入れても表示されない
      const ref = "A1:"+ xlsx.utils.encode_col(10) + currentRow;
      worksheet['!ref'] = ref

      const workbook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workbook,worksheet,"注文集計表")
      let sheetname = '注文集計表'+spreadsheetgetDay.format('YYYY/MM/DD')
      xlsx.writeFile(workbook,sheetname+".xlsx", { compression: true });

    }


    return {
        activeKey : ref('3'),
        itemactiveKey : ref('3-2'),
        deliveryActiveKey : ref('4-3'),
        loading,
        getCategoryLabel,
        handleResizeColumn,
        commodityVisible,
        commodityData,
        commodityColumns,
        commodityDataSource,
        commodityOK,
        commodityDelete,
        commodityEditOpen,
        input,
        fileSelect,
        selectedFile,
        categoryVisible,
        categoryData,
        categoryColumns,
        categoryDataSource,
        categoryOK,
        categoryDelete,
        categoryEditOpen,
        getParentCategory,
        pharmacyVisible,
        pharmacyData,
        pharmacyColumns,
        pharmacyDataSource,
        pharmacyOK,
        pharmacyDelete,
        pharmacyEditOpen,
        adminVisible,
        adminData,
        adminColumns,
        adminDataSource,
        adminOK,
        adminDelete,
        adminEditOpen,
        transporterVisible,
        transporterData,
        transporterColumns,
        transporterDataSource,
        transporterOK,
        transporterDelete,
        transporterEditOpen,
        userVisible,
        userData,
        userColumns,
        userDataSource,
        userOK,
        userDelete,
        userEditOpen,
        copyToClipboard,
        filterOption,
        expandedKeys,
        selectedKeys,
        treeData,
        treeVisible,
        setParent,
        categorySelect,
        categorySelectedKeys,
        categorySelectVisible,
        editexpandedKeys,
        editselectedKeys,
        receiptColumns,
        receiptDataSource,
        receiptVisible,
        receiptData,
        loadReceipt,
        ReceiptDetailColumns,
        ReceiptDetailDataSource,
        getRealcode,
        receiptOK,
        commodityDetailColumns,
        commodityDetailAdd,
        commodityDetailRemove,
        commodityDisable,
        categoryDisabled,
        shopColumns,
        shopDataSource,
        shopVisible,
        shopData,
        shopDelete,
        shopEditOpen,
        shopOK,
        getTaxPrice,
        getDetailRecord,
        getPointCardCode,
        getPOSJANCode,
        getDeliveryColumnsPOSJANCode,
        prepareDeliveryColumns,
        orderSummaryColumns,
        OrderSummaryDataSource,
        treeDataMyShop,
        myShopCategoryDataSource,
        saleonly,
        saleonlyChange,
        commodityDataSourceIsSale,
        salealldelete,
        couponVisible,
        couponData,
        couponColumns,
        couponDataSource,
        couponOK,
        couponDelete,
        couponEditOpen,
        couponcommodityDetail,
        getDeliveryColumnsPickType,
        ReceiptDownload,
        dlReceiptData,
        commodityCopy,
        spreadsheetColumns,
        spreadsheetDataSource,
        getSpreadsheet,
        spreadsheetSelectDay,
        spreadsheetCount,
        spreadsheetSum,
        downloadSpreadsheet,
        locale,
    }
  }
})
